import script from "./UpdateProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateProfileView.vue?vue&type=script&setup=true&lang=js"

import "./UpdateProfileView.vue?vue&type=style&index=0&id=2d27ce13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d27ce13"]])

export default __exports__